export const DEFAULT_MESSAGES = {
  REQUIRED: "Este campo es obligatorio",
  MIN_NUMBER: (n) => `El número debe ser al menos ${n}`,
  MAX_NUMBER: (n) => `El número debe ser como máximo ${n}`,
  INVALID_TIME: "Hora ingresada invalida",
};
